import { Api } from "api";

export const getBridgeMethods = async (page?: number) => {
  let url = "/mini_apps/v1/admin/bridge_methods";
  const res = await Api.get(`${url}`, { params: { page }});
  return res.data;
};

export const createBridgeMethod = async (payload: any) => {
  const res = await Api.post("/mini_apps/v1/admin/bridge_methods", payload);
  return res.data;
};

export const editBridgeMethod = async (name: string, payload: any) => {
  const res = await Api.put(
    `/mini_apps/v1/admin/bridge_methods/${name}`,
    payload,
  );
  return res.data;
};

export const deleteBridgeMethod = async (name: string) => {
  const res = await Api.delete(`/mini_apps/v1/admin/bridge_methods/${name}`);
  return res.data;
};
